import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  padding-left: 10px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;
const CheckboxWrapper = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const DefaultCheckbox = styled.input`
  display: none;
`;
const ChebkboxLable = styled.label`
  width: 20px;
  height: 20px;
  cursor: ${props => props.disabled && 'default'};
`;

const Checkbox = ({ checkboxKey, checked, onCheck, disabled }) => (
  <Wrapper
    id={`checkbox${checkboxKey}`}
    role="presentation"
    onClick={e => {
      e.stopPropagation();
      if (!disabled) {
        onCheck(!checked);
      }
    }}
  >
    <CheckboxWrapper
      id={`checkbox-wrapper${checkboxKey}`}
      role="presentation"
      onClick={e => e.stopPropagation()}
    >
      <DefaultCheckbox
        id={`checkbox-${checkboxKey}`}
        type="checkbox"
        onChange={e => onCheck(e.target.checked)}
        checked={checked ? 'checked' : ''}
        disabled={disabled}
      />
      <ChebkboxLable
        className="timelineCheckboxLabel"
        htmlFor={`checkbox-${checkboxKey}`}
        disabled={disabled}
      />
    </CheckboxWrapper>
  </Wrapper>
);

Checkbox.propTypes = {
  checkboxKey: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onCheck: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
Checkbox.defaultProps = {
  disabled: false,
};

export default Checkbox;
